import Utils from "../util/Utils"

export function TableLine(props) {
    let { label, value } = props
    const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[\+\-]\d{2}:\d{2})?$/;
    if ((value && isNaN(new Date(value).getTime()))||isoDateTimeRegex.test(value)){
        if (!isNaN(new Date(value))) {
            value = Utils.formatDateBooking(value, false);
        } else {
            value = Utils.reformatSuffixedDate(value);
        }
    }
    if (value) {
        return (
            <div style={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: '6px', textAlign: 'left', width: '100%' }}>
                <span style={{ fontWeight: 'bold', textAlign: 'left' }}>{label}</span>
                <span style={{ overflowWrap: 'anywhere', textAlign: 'left' }}>{value}</span>
            </div>
        )
    }
    return <></>
}